import React from "react";
import { useTranslation } from "react-i18next";
import { Layout } from "antd";
import { translator } from "../../../constants/actionTypes";
import { localStorageHelper } from "../../../utils/storageHelper";
import "./footerStyle.scss";

const { Footer } = Layout;

const FooterView = () => {
  const { t } = useTranslation();
  const currentTenantId = localStorageHelper.get("localTenantId");
  const allowedTenants = [
    "0108dcf6-0e40-472a-a82c-5a405acf6d6c",
    "e8650b3c-1a3d-454a-89b1-7dae1cb0a01d",
    "6f04e4e0-e3fb-45e1-a46f-1b9862f62680",
    "6ebb94a1-63e5-459b-9e84-371871cd0424",
  ];

  const showTerms = allowedTenants.includes(currentTenantId);

  return (
    <Footer className="footerWraper display-flex items-center">
      <span className="companyname"> {t("mmlIiht")}</span>
      {showTerms && (
        <span className="terms-condition-container">
          {t("termsAndCondition")}{" "}
          <a
            href={`${translator?.baseURL}/mml_files_dir/mml_pdf_dir/terms_and_agreement_randstad.pdf`}
            target="_blank"
            rel="noreferrer"
          >
            {t("agreement")}
          </a>
        </span>
      )}
    </Footer>
  );
};

export default FooterView;
